/**
 * Placeholder dashboard data. Replace each export with the corresponding API
 * response once the reporting endpoints are available.
 */

export const COMPARISON_DATE = "01 Jan 2026";

export const KPIS = [
  {
    key: "total",
    label: "Total Taxpayers",
    value: "3.20M",
    delta: "8.7%",
    tone: "blue",
    icon: "users",
  },
  {
    key: "active",
    label: "Active Taxpayers",
    value: "1.24M",
    delta: "6.4%",
    tone: "sky",
    icon: "user",
  },
  {
    key: "compliance",
    label: "Compliance Rate",
    value: "92.4%",
    delta: "4.1%",
    tone: "green",
    icon: "shield",
  },
  {
    key: "quality",
    label: "Data Quality Score",
    value: "96.8%",
    delta: "6.3%",
    tone: "indigo",
    icon: "database",
  },
  {
    key: "high-risk",
    label: "High Risk Taxpayers",
    value: "2,156",
    delta: "12.3%",
    tone: "red",
    icon: "alert",
  },
  {
    key: "alerts",
    label: "Open Alerts",
    value: "328",
    delta: "9.7%",
    tone: "amber",
    icon: "bell",
  },
];

export const RISK_SEGMENTS = [
  {
    label: "High Risk",
    value: 15,
    share: 15,
    display: "480K",
    color: "#df3f45",
  },
  {
    label: "Medium Risk",
    value: 35,
    share: 35,
    display: "1.12M",
    color: "#ef9c17",
  },
  {
    label: "Low Risk",
    value: 50,
    share: 50,
    display: "1.60M",
    color: "#26a269",
  },
];

export const COMPLIANCE_TREND = [
  { label: "Jan", value: 58 },
  { label: "Feb", value: 65 },
  { label: "Mar", value: 66 },
  { label: "Apr", value: 79 },
  { label: "May", value: 83 },
  { label: "Jun", value: 84 },
  { label: "Jul", value: 87 },
  { label: "Aug", value: 92.4 },
  { label: "Sep", value: 92.4 },
];

export const DATA_QUALITY = [
  {
    key: "duplicates",
    label: "Duplicates",
    value: "1,245",
    delta: "5.2%",
    tone: "blue",
    icon: "copy",
  },
  {
    key: "missing",
    label: "Missing Data",
    value: "3,678",
    delta: "7.8%",
    tone: "amber",
    icon: "missing",
  },
  {
    key: "conflicts",
    label: "Conflicts",
    value: "892",
    delta: "3.6%",
    tone: "indigo",
    icon: "conflict",
  },
  {
    key: "outdated",
    label: "Outdated Records",
    value: "2,430",
    delta: "4.9%",
    tone: "green",
    icon: "clock",
  },
];

export const ALERTS = [
  {
    id: 1,
    title: "Possible shell company detected",
    taxpayer: "Alpha Traders Ltd.",
    nif: "200-234-567",
    type: "AI Risk Detection",
    risk: "High",
    date: "01 Sep 2026",
    time: "10:42 AM",
    status: "New",
  },
  {
    id: 2,
    title: "VAT information mismatch",
    taxpayer: "Prime Logistics SARL",
    nif: "300-345-678",
    type: "Data Conflict",
    risk: "Medium",
    date: "01 Sep 2026",
    time: "09:15 AM",
    status: "In Review",
  },
  {
    id: 3,
    title: "Duplicate taxpayer record",
    taxpayer: "ABC Trading Ltd.",
    nif: "100-456-789",
    type: "Data Quality",
    risk: "Medium",
    date: "01 Sep 2026",
    time: "08:32 AM",
    status: "New",
  },
  {
    id: 4,
    title: "Document expiring soon",
    taxpayer: "Delta Services Ltd.",
    nif: "400-567-890",
    type: "Compliance",
    risk: "Low",
    date: "01 Sep 2026",
    time: "07:50 AM",
    status: "New",
  },
];

export const ALERT_TABS = [
  { key: "all", label: "All", count: 328 },
  { key: "High", label: "High", count: 72 },
  { key: "Medium", label: "Medium", count: 146 },
  { key: "Low", label: "Low", count: 110 },
];

export const SYSTEM_OVERVIEW = [
  {
    key: "sync",
    icon: "sync",
    label: "Last Data Synchronization",
    value: "2 min ago",
    hint: "01 Sep 2026, 10:45 AM",
  },
  {
    key: "sources",
    icon: "database",
    label: "Connected Data Sources",
    value: "7 / 10",
  },
  {
    key: "uptime",
    icon: "shield",
    label: "System Uptime",
    value: "99.92%",
    hint: "Last 30 days",
    tone: "good",
  },
  {
    key: "users",
    icon: "users",
    label: "Total Users",
    value: "186",
    hint: "Active users",
  },
  {
    key: "cases",
    icon: "cases",
    label: "Audit Cases in Progress",
    value: "48",
  },
];
